// Login.js
import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, getAuth,   setPersistence,
  browserLocalPersistence  } from 'firebase/auth';
import { auth } from './firebase';
import { signInWithGoogle, updateUserClaims } from './utils';


import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        onLoginSuccess(user);
      }
    });

    return () => unsubscribe();
  }, [onLoginSuccess]);

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    await setPersistence(auth, browserLocalPersistence);
    const result = await signInWithGoogle();
    
    if (result.success) {
      await updateUserClaims();
      onLoginSuccess(result.user);
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img 
            src="/Neodonya_Logo.png" 
            alt="Neodonya Recruit" 
            className="company-logo"
          />
        </div>
        
        <div className="login-section">
          <h2 className="login-title">Sign In</h2>
          {/* <p className="login-subtitle">Sign in to start your application. It won’t take long</p> */}
          
          <button 
            className="google-btn-3d"
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            <div className="btn-content">
              <div className="google-icon">
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </div>
              <span className="btn-text">
                {loading ? 'Signing in...' : 'Continue with Google'}
              </span>
            </div>
            {loading && <div className="loading-overlay"></div>}
          </button>
        </div>
        
        {error && (
          <div className="error-message">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="2"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="2"/>
            </svg>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;